import { createContext, useContext, useState, useEffect, useCallback } from "react";

const WorkspaceContext = createContext({
  workspace: "ventas",
  setWorkspace: () => {},
  canAccessVentas: true,
  canAccessOperacion: true,
});

export const WorkspaceProvider = ({ user, children }) => {
  const workspaceRol = user?.workspace_rol || (user?.role === "superadmin" || user?.role === "admin" ? "admin" : "admin");

  const canAccessVentas = workspaceRol === "ventas" || workspaceRol === "admin";
  const canAccessOperacion = workspaceRol === "operacion" || workspaceRol === "admin";

  const defaultWs = workspaceRol === "operacion" ? "operacion" : "ventas";

  const [workspace, setWorkspaceState] = useState(() => {
    const stored = localStorage.getItem("celebramid_workspace");
    if (stored === "ventas" && canAccessVentas) return "ventas";
    if (stored === "operacion" && canAccessOperacion) return "operacion";
    return defaultWs;
  });

  const setWorkspace = useCallback((ws) => {
    if (ws === "ventas" && !canAccessVentas) return;
    if (ws === "operacion" && !canAccessOperacion) return;
    setWorkspaceState(ws);
    localStorage.setItem("celebramid_workspace", ws);
  }, [canAccessVentas, canAccessOperacion]);

  useEffect(() => {
    // Si el rol cambió y el ws actual no es accesible, switch
    if (workspace === "ventas" && !canAccessVentas) setWorkspaceState("operacion");
    if (workspace === "operacion" && !canAccessOperacion) setWorkspaceState("ventas");
  }, [canAccessVentas, canAccessOperacion, workspace]);

  return (
    <WorkspaceContext.Provider value={{ workspace, setWorkspace, canAccessVentas, canAccessOperacion, workspaceRol }}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export const useWorkspace = () => useContext(WorkspaceContext);
